import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['serviceCheck', 'button']

  static values = {
    maxServices: { type: Number, default: 3 },
  }

  connect() {
    this.toggleButton()
    setTimeout(() => this.scrollToFirstSelectedService(), 50)
  }

  toggle(event) {
    if (this.selectedServicesIds.length > this.maxServicesValue) {
      event.target.checked = false
      return
    }

    this.toggleCheckedStatus(event.target.value, event.target.checked)
    this.toggleButton()
  }

  toggleButton() {
    this.buttonTarget.disabled = this.selectedServicesIds.length === 0
  }

  toggleCheckedStatus(serviceId, checked) {
    this.serviceCheckTargets
      .filter(
        (checkbox) =>
          checkbox.value === serviceId && checkbox.checked !== checked
      )
      .forEach((checkbox) => (checkbox.checked = checked))
  }

  scrollToFirstSelectedService() {
    const service = this.serviceCheckTargets.find(
      (checkbox) => checkbox.checked
    )

    if (service) {
      service.nextElementSibling.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  get selectedServicesIds() {
    return Array.from(
      new Set(
        this.serviceCheckTargets
          .filter((checkbox) => checkbox.checked)
          .map((checkbox) => checkbox.value)
      )
    )
  }
}
